import Button from 'src/components/design-system/Button';
import GuideMeTitleBar from 'src/components/GuideMeTitleBar';
import { CanUsesInitialBudgets } from 'src/constants/permissionsList';
import usePermission from 'src/hooks/usePermissions';

const FirstSlide = () => (
  <ul className="px-4 font-bold text-[13px]">
    <li className="list-disc font-semibold">
      Invoice or Credit Memo documents sent to you for approval will appear in the bottom table.
    </li>
    <li className="list-disc font-semibold">
      Select all, or select specific records and then use the buttons provided to approve, decline,
      or submit to another user for further approval.
    </li>
    <li className="list-disc font-semibold">
      Use sort, filter, or the # of Items per Page tools to change the number of or the type of
      records shown.
    </li>
  </ul>
);

const SecondSlide = () => {
  const usesBudgets = usePermission({ permissions: CanUsesInitialBudgets });

  return (
    <ul className="px-4 font-bold text-[13px]">
      <li className="list-disc font-semibold">
        {usesBudgets
          ? 'Current forecast remaining balance and budget remaining balance for each GL account and accounting period will appear in the top table for all invoices listed in the table below.'
          : 'Current forecast remaining balance for each GL account and accounting period will appear in the top table for all invoices listed in the table below.'}
      </li>
      <li className="list-disc font-semibold">
        Click on a GL account code to view records containing that value.
      </li>
      <li className="list-disc font-semibold">
        Click on the{' '}
        <Button color="secondary" className="inline-block" readonly={true}>
          View
        </Button>{' '}
        in the Transaction Log column to view all transactions for the GL Code and Accounting Period
        present in the row.
      </li>
    </ul>
  );
};

const ThirdSlide = () => (
  <ul className="px-4 font-bold text-[13px]">
    <li className="list-disc font-semibold">
      Use the icons on the invoice row to assess the current status of that invoice.
    </li>
    <li className="list-disc font-semibold">
      Icons will display in red indicating it was a reason that the records requires review or
      approval, and will display in yellow indicating that status of the document is true.
    </li>
    <li className="list-disc font-semibold">
      Click on the{' '}
      <span
        className={`w-[22px] h-[22.5px] pb-[1px] text-white rounded-full cursor-pointer ${'bg-primary'}  inline-block text-center`}
      >
        S
      </span>{' '}
      or{' '}
      <span
        className={`w-[22px] h-[22.5px] pb-[1px] text-white rounded-full cursor-pointer ${'bg-info'} inline-block text-center`}
      >
        M
      </span>{' '}
      in the GL Summary column to view single or multiple period expense breakdown for the record.
    </li>
  </ul>
);

export const guideMeSteps = [
  {
    content: <FirstSlide />,
    title: <GuideMeTitleBar title="Action Required for Invoices/Credits" />,
  },
  {
    content: <SecondSlide />,
    title: <GuideMeTitleBar title="Action Required for Invoices/Credits" />,
  },
  {
    content: <ThirdSlide />,
    title: <GuideMeTitleBar title="Action Required for Invoices/Credits" />,
  },
];
